import { registerComponent } from '@gig/magic-common';
import SignUpV2Component from './sign-up.vue.js';

var SignUp = registerComponent(SignUpV2Component);

export { SignUp };
